import Vue from 'vue'
import { bizComponentList } from './config'
import { EleFormBuiltInNames } from '@meta-vue/vue-ele-form'
bizComponentList.forEach(({ miniKey, type }) => {
  const comName = getComponentName(type)
  const component = Vue.options.components[comName]
  if (component) {
    Vue.component(miniKey, component)
  }
})
// 组件名称
function getComponentName(type) {
  if (EleFormBuiltInNames && EleFormBuiltInNames.includes(type)) {
    // 内置组件
    return 'EleForm' + titleCase(type)
  } else {
    // 外部组件
    return type
  }
}
function titleCase(str) {
  try {
    return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase()
  } catch (error) {
    console.log(error)
    return str
  }
}
